"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAssetRequestSchema = exports.AdminAssetsResponseSchema = exports.AdminAssetSchema = exports.UpdateChainRequestSchema = exports.AdminChainsResponseSchema = exports.AdminChainSchema = exports.UpdateSettingRequestSchema = exports.AdminSettingsResponseSchema = exports.AdminSettingSchema = void 0;
const zod_1 = require("zod");
const registry_1 = require("../../settings/registry");
const wallet_1 = require("../wallet");
const common_1 = require("./common");
exports.AdminSettingSchema = zod_1.z.object({
    key: zod_1.z.enum(registry_1.SETTING_KEYS),
    group: zod_1.z.string(),
    label: zod_1.z.string(),
    description: zod_1.z.string(),
    unit: zod_1.z.string().nullable(),
    value: zod_1.z.unknown(),
    default: zod_1.z.unknown(),
    /** JSON Schema-ish hints for the form: number bounds, nullable string, or a boolean switch. */
    kind: zod_1.z.enum(['integer', 'string', 'boolean']),
    min: zod_1.z.number().nullable(),
    max: zod_1.z.number().nullable(),
    nullable: zod_1.z.boolean(),
    updatedAt: zod_1.z.iso.datetime().nullable(),
    updatedBy: common_1.StaffRefSchema.nullable(),
});
exports.AdminSettingsResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.AdminSettingSchema) });
exports.UpdateSettingRequestSchema = zod_1.z.object({ value: zod_1.z.unknown() });
exports.AdminChainSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    code: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.enum(['evm', 'tron']),
    nativeSymbol: zod_1.z.string(),
    explorerUrlTemplate: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
    sortOrder: zod_1.z.number().int(),
});
exports.AdminChainsResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.AdminChainSchema) });
exports.UpdateChainRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(60).optional(),
    explorerUrlTemplate: zod_1.z.string().includes('{address}').max(300).optional(),
    enabled: zod_1.z.boolean().optional(),
    sortOrder: zod_1.z.number().int().min(0).max(1000).optional(),
})
    .refine((body) => Object.values(body).some((v) => v !== undefined), {
    message: 'Nothing to update',
});
exports.AdminAssetSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    chainId: zod_1.z.uuid(),
    chainCode: zod_1.z.string(),
    code: zod_1.z.string(),
    symbol: zod_1.z.string(),
    name: zod_1.z.string(),
    decimals: zod_1.z.number().int(),
    contractAddress: zod_1.z.string().nullable(),
    minDeposit: wallet_1.AtomicAmountSchema,
    enabled: zod_1.z.boolean(),
    sortOrder: zod_1.z.number().int(),
    /** Users that already have this asset provisioned; a change in minDeposit does not reach them (spec 3.2). */
    tenantCount: zod_1.z.number().int(),
    /** The catalogue-level withdraw switch (spec 6, 10); flipping it fans out to every tenant already provisioned. */
    withdrawEnabled: zod_1.z.boolean(),
});
exports.AdminAssetsResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.AdminAssetSchema) });
exports.UpdateAssetRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1).max(60).optional(),
    minDeposit: wallet_1.AtomicAmountSchema.optional(),
    enabled: zod_1.z.boolean().optional(),
    sortOrder: zod_1.z.number().int().min(0).max(1000).optional(),
    /** Routed through `AdminWithdrawFlagsService.setAssetFlag`, never written directly (spec 6, 10). */
    withdrawEnabled: zod_1.z.boolean().optional(),
})
    .refine((body) => Object.values(body).some((v) => v !== undefined), {
    message: 'Nothing to update',
});
//# sourceMappingURL=settings.js.map